import React from 'react';
import styles from './WhoWeAre.module.css';

const WhoWeAre = () => {
  const stats = [
    { number: '10+', label: 'Projects Completed' },
    { number: '98%', label: 'Client Satisfaction' },
    { number: '15+', label: 'Industries Explored' }
  ];

  return (
    <section id="who-we-are" className={`${styles.whoWeAre} section`}>
      <div className="container">
        <h2 className="section-title fade-in">Who We Are</h2>
        <div className={styles.aboutGrid}>
          <div className={`${styles.aboutText} fade-in`}>
            <p>At Analytica X, we are passionate data scientists, analysts, and business strategists who believe in the transformative power of data. Founded with a vision to democratize advanced analytics, we help businesses of all sizes harness their data to drive meaningful growth.</p>
            
            <p>Our team combines deep technical expertise with business acumen, ensuring that our solutions don't just provide insights—they drive action. We've worked across industries, from startups to Fortune 500 companies, helping them navigate the complex world of data analytics.</p>
            
            <p>What sets us apart is our commitment to understanding your unique business challenges first, then crafting tailored analytical solutions that deliver measurable results. We don't just crunch numbers; we unlock the stories your data tells.</p>
          </div>
          <div className="fade-in">
            <div className={styles.stats}>
              {stats.map((stat, index) => (
                <div key={index} className={styles.statItem}>
                  <span className={styles.statNumber}>{stat.number}</span>
                  <div className={styles.statLabel}>{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhoWeAre;
